import React, { useContext, useState } from 'react'
import SmallModal from '../../../../components/Modals/SmallModal'
import API from '../../../../services/API'
import { GlobalContext } from '../../../../App'

import Button from '@mui/material/Button'
import ButtonGroup from '@mui/material/ButtonGroup'
import Chip from '@mui/material/Chip'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

const MandatoryTrainingApproval = ({ courseID }) => {
  const [showConfirmation, setShowConfirmation] = useState(null)
  const [menuAnchor, setMenuAnchor] = useState(null)
  const { setToast } = useContext(GlobalContext)

  const handleSubmit = () => {
    API.post('/mandatorytraining/review-upload', {
      courseID,
      action: showConfirmation,
    }).then((res) => {
      if (res.status === 200) {
        setToast({ message: 'Training Record Updated' })
        window.location.reload()
      } else {
        setToast({
          message: 'Unable to update training record. Please try again later',
          severity: 'error',
        })
      }
    })
  }
  return (
    <>
      <Chip
        label="Requires Approval"
        color="warning"
        onClick={(e) => setMenuAnchor(e.currentTarget)}
        sx={{ cursor: 'pointer', borderRadius: 1 }}
      />
      <Menu
        open={!!menuAnchor}
        anchorEl={menuAnchor}
        onClose={() => setMenuAnchor(null)}
      >
        <MenuItem onClick={() => setShowConfirmation('accept')}>
          Accept
        </MenuItem>
        <MenuItem onClick={() => setShowConfirmation('reject')}>
          Reject
        </MenuItem>
      </Menu>
      <SmallModal
        open={!!showConfirmation}
        onClose={() => setShowConfirmation(null)}
      >
        <Stack>
          <Typography variant="title3" textAlign="center">
            Are you sure you want to {showConfirmation} this training record?
          </Typography>
          <ButtonGroup fullWidth variant="contained">
            <Button onClick={handleSubmit} color="success">
              Yes
            </Button>
            <Button onClick={() => setShowConfirmation(null)} color="error">
              No
            </Button>
          </ButtonGroup>
        </Stack>
      </SmallModal>
    </>
  )
}

export default MandatoryTrainingApproval
